<template>
  <v-app>
    <v-app-bar color="white" fixed> 
        <a href="/" class="pt-4"><img link  src="../../x.m.works/src/assets/img/logo-dark.png" height="70" class="mr-2 mb-4 pt-5" /></a>
        <span class="mw-logo-font d-none d-sm-block mt-7">Meisterworks <br/>Market Research</span>
      <v-spacer></v-spacer>
      <v-btn x-small color="black" dark class="mr-3" v-if="logged_in" link href="/profile"><v-icon small class="mr-3">mdi-account</v-icon> My Account</v-btn>       
           
      <v-btn x-small color="black" dark link v-if="!logged_in" href="https://beta.m.works"><v-icon small class="mr-3">mdi-briefcase</v-icon> For Clients</v-btn>
      <LoginModal color="black" :size="{'x-small': true}"></LoginModal>
      <LogoutModal color="black" :size="{'x-small': true}"></LogoutModal>
      <template v-slot:extension>
        <NavigationTop></NavigationTop>
      </template>
    </v-app-bar>
    <v-main style="margin-top: 70px">
          <router-view ></router-view>
    </v-main>

    <Footer></Footer>
  </v-app>
</template>

<script>
import Vuex from 'vuex'
import LoginModal from "@/components/LoginModal"
import LogoutModal from "@/components/LogoutModal"
import Footer from "@/components/Footer"
import NavigationTop from "@/components/NavigationTop"

import visitor from "../src/store/modules/Visitor.js"
import panelmember from "../src/store/modules/PanelMember.js"

export default {
  name: 'App',
  computed: {
    ...Vuex.mapState({
      user: state => state.auth.user,
      view: state => state.auth.view,
      logged_in: state => state.auth.logged_in,
    })
  },
  components: {
    Footer,
    NavigationTop,
    LoginModal,
    LogoutModal
  },
  data: () => ({
    // drawer: null
  }),
  watch:{ 
    $route() {
      document.title = 'MW Research'
    },
    view: {
      immediate: true,
      handler(view) {
        if( !view ){
          return;
        }
        const self = this;
        self.$store.dispatch('checkUserStatus').then( () => {    } ).catch(() => {});
        switch(view){
          case "panelmember": 
          this.$store.registerModule("panelmember", panelmember)
          this.$store.dispatch("fetchUser");
          break;
          default: 
          this.$store.registerModule("visitor", visitor )
          break;
        }
      }
    },
  },
  methods: {
    redirect(){
      this.$router.push("/")
    }
  },
  created(){
    document.title = 'MW Research'
  }
};
</script>


<style lang="less">
  body, html{
    font-family: Roboto,sans-serif
  }
  .mw-logo-font{
    font-weight: 200;
    text-transform: uppercase;
    font-size: 0.9em;
  }

  .text-large{
    font-size: 1.2em;
  }
  .text-larger{
    font-size: 1.7em;
  }
  .primary--background{
    background-color: #5b6f85;
  }
</style>